<div
  class="fmt-seg"
  [class.compact]="compact()"
  [class.on-1]="value() === 1"
  [class.is-disabled]="disabled()"
>
  <div class="indicator"></div>
  @for (opt of options; track opt.value) {
    <button
      type="button"
      class="seg"
      [class.active]="value() === opt.value"
      [attr.aria-pressed]="value() === opt.value"
      (click)="select(opt)"
    >
      {{ opt.label }}
      @if (opt.value === 1) {
        <span class="new-badge" aria-hidden="true">NEW</span>
      }
    </button>
  }
</div>
